import type { GenericComponent, WrapProps } from "../types";

export default function GenericWrap({
	component: Component,
	props,
}: WrapProps<GenericComponent> & {
	props: Record<string, unknown>;
}) {
	return <Component {...props} />;
}
